var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fonts-wrapper", class: { active: _vm.activeOverlay } },
    [
      _c("span", { staticClass: "caption ft-xbld" }, [
        _vm._v(_vm._s(_vm.caption)),
      ]),
      _vm._v(" "),
      _c("div", { ref: "outer", staticClass: "fonts-outer" }, [
        _c(
          "div",
          {
            staticClass: "dft-preview",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleFonts.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "txt", class: _vm.Global.mockupConfig.activeFont },
              [_vm._v(_vm._s(_vm.currentFont))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "arw" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeOverlay,
                expression: "activeOverlay",
              },
            ],
            staticClass: "expand-outer",
          },
          [
            _c("div", { staticClass: "bg" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "in" },
              [
                _c(
                  "div",
                  {
                    staticClass: "line ft-bld",
                    class: { active: _vm.currentFont === "Inter" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.fontSelection("Inter", "inter")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "name" }, [_vm._v("Inter")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "prev" }, [_vm._v("Abc")]),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.fonts, function (font, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "line",
                      class: [
                        font.className,
                        { active: _vm.currentFont === font.caption },
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.fontSelection(font.caption, font.className)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(font.caption)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "prev" }, [_vm._v("Abc")]),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }